export enum FormFieldLabel {
  ASSIGNMENT_OBJECTIVES = 'Assignment Objectives'
}
